import { apiClient } from './client';
import { AgentLog, LogStats, LogOperation } from '../types';

interface LogFilters {
  workspace?: string;
  agent?: string;
  operation?: LogOperation;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}

export async function getLogs(filters: LogFilters = {}): Promise<AgentLog[]> {
  const params = new URLSearchParams();

  if (filters.workspace) params.append('workspace', filters.workspace);
  if (filters.agent) params.append('agent', filters.agent);
  if (filters.operation) params.append('operation', filters.operation);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.limit) params.append('limit', String(filters.limit));
  if (filters.offset) params.append('offset', String(filters.offset));

  const query = params.toString();
  return apiClient<AgentLog[]>(`/logs${query ? `?${query}` : ''}`);
}

export async function getLogStats(): Promise<LogStats> {
  return apiClient<LogStats>('/logs/stats');
}

export async function exportLogs(
  filters: LogFilters = {},
  format: 'json' | 'csv' = 'json'
): Promise<Blob> {
  const params = new URLSearchParams();

  if (filters.workspace) params.append('workspace', filters.workspace);
  if (filters.agent) params.append('agent', filters.agent);
  if (filters.operation) params.append('operation', filters.operation);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  params.append('format', format);

  const query = params.toString();
  const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

  const response = await fetch(`${API_BASE}/logs/export?${query}`);
  if (!response.ok) {
    throw new Error('Export failed');
  }

  return response.blob();
}
